<template>
	<type-wrapper class="type-D" limit :bgUrl="showData.image">
		<type-grid row="1" margin v-if="showData.title || showData.content">
			<type-title large v-if="showData.title">{{ showData.title }}</type-title>
			<type-content large center v-if="showData.content">{{ showData.content }}</type-content>
		</type-grid>
		<type-grid :row="showData.block.length" v-for="(item, index) in showData.block" :key="index">
			<div class="type-D-block">
				<type-title medium v-if="showData.title">{{ item.title }}</type-title>
				<type-content large v-if="showData.content">{{ item.content }}</type-content>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 三分四分同主题文
	import mixin from '../mixin.js'
	export default {
		name: 'type-D',
		mixins: [ mixin ]
	}
</script>

<style scoped lang="less">
	.type-D{
		display: flex;
		flex-wrap: wrap;
		.type-D-block{
			padding: 25px;
			margin: 0 25px 25px;
			width: calc(100% - 100px);
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			background-color: rgba(0, 0, 0, 0.5);
		}
	}
</style>
